/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
export const pickerIconNames = [
  "symbol-roofing",
  "symbol-construction",
  "symbol-handyman",
  "symbol-hardware",
  "symbol-build",
  "symbol-home-repair-service",
  "symbol-plumbing",
  "symbol-carpenter",
  "symbol-electrical-services",
  "symbol-architecture",
  "symbol-engineering",
  "symbol-foundation",
  "symbol-fence",
  "symbol-deck",
  "symbol-format-paint",
  "symbol-imagesearch-roller",
  "symbol-design-services",
  "symbol-straighten",
  "symbol-square-foot",
  "symbol-hvac",
  "symbol-solar-power",
  "symbol-water-damage",
  "symbol-pest-control",
  "symbol-cleaning-services",
  "symbol-precision-manufacturing",
  "symbol-tools-power-drill",
  "symbol-tools-ladder",
  "symbol-tools-level",
  "symbol-tools-pliers-wire-stripper",
  "symbol-tools-flat-head",
  "symbol-agriculture",
  "symbol-forklift",
  "symbol-front-loader",
  "symbol-fire-extinguisher",
  "symbol-home",
  "symbol-cottage",
  "symbol-villa",
  "symbol-house",
  "symbol-cabin",
  "symbol-chalet",
  "symbol-bungalow",
  "symbol-gite",
  "symbol-other-houses",
  "symbol-holiday-village",
  "symbol-apartment",
  "symbol-domain",
  "symbol-corporate-fare",
  "symbol-location-city",
  "symbol-warehouse",
  "symbol-garage",
  "symbol-garage-home",
  "symbol-factory",
  "symbol-store",
  "symbol-storefront",
  "symbol-castle",
  "symbol-church",
  "symbol-school",
  "symbol-stadium",
  "symbol-account-balance",
  "symbol-hotel",
  "symbol-real-estate-agent",
  "symbol-home-work",
  "symbol-yard",
  "symbol-local-hospital",
  "symbol-museum",
  "symbol-festival",
  "symbol-park",
  "symbol-forest",
  "symbol-nature",
  "symbol-eco",
  "symbol-grass",
  "symbol-potted-plant",
  "symbol-local-florist",
  "symbol-landscape",
  "symbol-volcano",
  "symbol-water-drop",
  "symbol-water",
  "symbol-waves",
  "symbol-tsunami",
  "symbol-flood",
  "symbol-sunny",
  "symbol-partly-cloudy-day",
  "symbol-cloud",
  "symbol-rainy",
  "symbol-thunderstorm",
  "symbol-storm",
  "symbol-tornado",
  "symbol-foggy",
  "symbol-air",
  "symbol-ac-unit",
  "symbol-severe-cold",
  "symbol-sunny-snowing",
  "symbol-bedtime",
  "symbol-nightlight",
  "symbol-wb-twilight",
  "symbol-local-fire-department",
  "symbol-whatshot",
  "symbol-public",
  "symbol-compost",
  "symbol-energy-savings-leaf",
  "symbol-pets",
  "symbol-cruelty-free",
  "symbol-raven",
  "symbol-emoji-nature",
  "symbol-bug-report",
  "symbol-sound-detection-dog-barking",
  "symbol-set-meal",
  "symbol-egg",
  "symbol-phishing",
  "symbol-directions-car",
  "symbol-electric-car",
  "symbol-local-shipping",
  "symbol-local-taxi",
  "symbol-airport-shuttle",
  "symbol-rv-hookup",
  "symbol-fire-truck",
  "symbol-two-wheeler",
  "symbol-moped",
  "symbol-pedal-bike",
  "symbol-directions-bus",
  "symbol-train",
  "symbol-tram",
  "symbol-subway",
  "symbol-flight",
  "symbol-rocket-launch",
  "symbol-rocket",
  "symbol-sailing",
  "symbol-directions-boat",
  "symbol-anchor",
  "symbol-snowmobile",
  "symbol-explore",
  "symbol-map",
  "symbol-place",
  "symbol-navigation",
  "symbol-route",
  "symbol-signpost",
  "symbol-tour",
  "symbol-luggage",
  "symbol-flag",
  "symbol-restaurant",
  "symbol-local-pizza",
  "symbol-lunch-dining",
  "symbol-dinner-dining",
  "symbol-brunch-dining",
  "symbol-bakery-dining",
  "symbol-ramen-dining",
  "symbol-kebab-dining",
  "symbol-rice-bowl",
  "symbol-tapas",
  "symbol-fastfood",
  "symbol-icecream",
  "symbol-cake",
  "symbol-cookie",
  "symbol-nutrition",
  "symbol-local-cafe",
  "symbol-coffee",
  "symbol-emoji-food-beverage",
  "symbol-local-bar",
  "symbol-wine-bar",
  "symbol-sports-bar",
  "symbol-liquor",
  "symbol-grocery",
  "symbol-kitchen",
  "symbol-blender",
  "symbol-outdoor-grill",
  "symbol-soup-kitchen",
  "symbol-sports-soccer",
  "symbol-sports-basketball",
  "symbol-sports-football",
  "symbol-sports-baseball",
  "symbol-sports-tennis",
  "symbol-sports-golf",
  "symbol-sports-volleyball",
  "symbol-sports-hockey",
  "symbol-sports-esports",
  "symbol-sports-motorsports",
  "symbol-sports-martial-arts",
  "symbol-sports",
  "symbol-fitness-center",
  "symbol-pool",
  "symbol-surfing",
  "symbol-downhill-skiing",
  "symbol-hiking",
  "symbol-skateboarding",
  "symbol-kayaking",
  "symbol-self-improvement",
  "symbol-trophy",
  "symbol-military-tech",
  "symbol-workspace-premium",
  "symbol-toys",
  "symbol-casino",
  "symbol-extension",
  "symbol-piano",
  "symbol-music-note",
  "symbol-headphones",
  "symbol-theaters",
  "symbol-movie",
  "symbol-videogame-asset",
  "symbol-celebration",
  "symbol-lightbulb",
  "symbol-key",
  "symbol-lock",
  "symbol-shield",
  "symbol-umbrella",
  "symbol-backpack",
  "symbol-watch",
  "symbol-diamond",
  "symbol-crown",
  "symbol-redeem",
  "symbol-shopping-cart",
  "symbol-shopping-bag",
  "symbol-local-mall",
  "symbol-payments",
  "symbol-credit-card",
  "symbol-savings",
  "symbol-account-balance-wallet",
  "symbol-attach-money",
  "symbol-paid",
  "symbol-sell",
  "symbol-receipt-long",
  "symbol-work",
  "symbol-business-center",
  "symbol-inventory-2",
  "symbol-package-2",
  "symbol-deployed-code",
  "symbol-palette",
  "symbol-brush",
  "symbol-draw",
  "symbol-photo-camera",
  "symbol-videocam",
  "symbol-mic",
  "symbol-smartphone",
  "symbol-computer",
  "symbol-keyboard",
  "symbol-memory",
  "symbol-smart-toy",
  "symbol-science",
  "symbol-biotech",
  "symbol-experiment",
  "symbol-psychology",
  "symbol-menu-book",
  "symbol-auto-stories",
  "symbol-book",
  "symbol-timer",
  "symbol-alarm",
  "symbol-hourglass-top",
  "symbol-calendar-month",
  "symbol-schedule",
  "symbol-campaign",
  "symbol-handshake",
  "symbol-volunteer-activism",
  "symbol-support-agent",
  "symbol-groups",
  "symbol-group",
  "symbol-person",
  "symbol-diversity-3",
  "symbol-mood",
  "symbol-face",
  "symbol-accessibility-new",
  "symbol-medical-services",
  "symbol-health-and-safety",
  "symbol-medication",
  "symbol-ecg-heart",
  "symbol-spa",
  "symbol-magic-button",
  "symbol-auto-awesome",
  "symbol-circle",
  "symbol-square",
  "symbol-change-history",
  "symbol-pentagon",
  "symbol-hexagon",
  "symbol-star",
  "symbol-favorite",
  "symbol-bolt",
  "symbol-flash-on",
  "symbol-hive",
  "symbol-interests",
  "symbol-category",
  "symbol-token",
  "symbol-label",
  "symbol-bookmark",
  "symbol-all-inclusive",
  "symbol-loyalty",
  "symbol-verified",
  "symbol-recommend",
  "symbol-thumb-up",
  "symbol-target",
  "symbol-ads-click",
  "symbol-adjust",
  "symbol-account-tree",
  "symbol-schema",
  "symbol-lan",
  "symbol-hub",
  "symbol-blur-on",
  "symbol-gesture",
] as const;
